import { FC } from 'react';

import Font from '../Font';
import Icon from '../Icon';
import { TootipElement } from './styles';

export type TooltipProps = {
  description?: string;
  label: string;
};
const Tooltip: FC<TooltipProps> = ({ description, label }) => (
  <TootipElement data-testid="tooltip-test-id">
    <Font variant="bodyRegular">{label}</Font>
    {description && (
      <div
        data-testid="icon-description"
        data-tip
        data-tooltip-content={description}
        data-tooltip-id="serviceItemTooltip"
      >
        <Icon iconName="InterfaceInfo" />
      </div>
    )}
  </TootipElement>
);

export default Tooltip;
